import { getDeviceInfo, supportedOperatingSystems } from "../../../../commons/libs/browser";
import useOnMount from "../../../commons/libs/hooks/use-on-mount";
import { useMobileAppDispatcher } from "../../store/hooks";

const usePwaInformationModal = () => {
  const [dispatch, actions] = useMobileAppDispatcher();

  useOnMount(() => {
    const isFullscreen = window.matchMedia("(display-mode: fullscreen)").matches;
    const deviceInfo = getDeviceInfo(navigator.userAgent);
    const browser = deviceInfo.browser.name;
    const operatingSystem = deviceInfo.os.name;

    // can only be in fullscreen mode if PWA is installed
    // this check must be kept in sync with the manifest display setting
    if (
      operatingSystem &&
      !isFullscreen &&
      ((operatingSystem && supportedOperatingSystems.includes(operatingSystem)) || browser === "Safari")
    ) {
      dispatch(actions.modal.showModal("pwaInformation", { operatingSystem }));
    }
  });
};

export default usePwaInformationModal;
